function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M116 12c-30.928 0-56 25.072-56 56h112c0-30.928-25.072-56-56-56z",
  fill: "#72AEFF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M114.5 12C92.132 12 74 37.072 74 68h81c0-30.928-18.132-56-40.5-56z",
  fill: "#5181B8"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 106,
  y: 8,
  width: 16,
  height: 6,
  rx: 2,
  fill: "#316299"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M73.566 68H156l-16.3 11.32a15 15 0 01-8.556 2.68H72.207c-4.326 0-6.61-5.12-3.721-8.34l5.08-5.66z",
  fill: "#5490E0"
});

function SvgAccessories1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "static/media/accessories-1.8ff1f4d4.svg";
export { SvgAccessories1 as ReactComponent };